import React from "react";

const PurchaseReturnItemsTable = ({
  items = [],
  setItems,
  returnReason,
  setReturnReason,
  handleSubmit,
  loading,
}) => {
  // Update a single item and recalculate its total
  // Discount is a percentage: total = (qty × rate) - ((qty × rate × discount%) / 100)
  const updateItem = (index, changes) => {
    const updated = items.map((it, i) => {
      if (i !== index) return it;
      const merged = { ...it, ...changes };
      const qty = Number(merged.return_quantity) || 0;
      const rate = Number(merged.product_rate) || 0;
      const disc = Number(merged.discount) || 0;
      const subtotal = qty * rate;
      merged.total = subtotal - (subtotal * disc) / 100;
      return merged;
    });
    setItems(updated);
  };

  const handleQty = (i, v) => {
    // Store raw string while typing to avoid 0-prefix issue
    // Clamp only when value is a complete number
    const raw = v;
    const num = Number(v);
    const max = Number(items[i].purchase_quantity);
    const clamped = num < 0 ? 0 : num > max ? max : num;
    // If user is mid-typing (e.g. empty string), keep raw; otherwise use clamped
    updateItem(i, { return_quantity: raw === "" ? "" : clamped });
  };

  const handleDisc = (i, v) => {
    const num = Number(v);
    const clamped = num < 0 ? 0 : num > 100 ? 100 : num;
    updateItem(i, { discount: v === "" ? "" : clamped });
  };

  const grandTotal = items.reduce((s, x) => s + Number(x.total || 0), 0);

  const canSubmit = items.some((i) => Number(i.return_quantity) > 0);

  return (
    <div className="table-responsive">
      <table className="table table-bordered align-middle">
        <thead>
          <tr>
            <th>Product</th>
            <th>Purchase Qty</th>
            <th>Available Qty</th>
            <th>Return Qty</th>
            <th>Rate (Per Unit $)</th>
            <th>Discount (%)</th>
            <th>Total</th>
          </tr>
        </thead>

        <tbody>
          {items.map((row, i) => (
            <tr key={i}>
              <td>
                <input
                  className="form-control bg-light"
                  value={row.product_name}
                  disabled
                />
              </td>
              <td>
                <input
                  className="form-control bg-light"
                  value={row.purchase_quantity}
                  disabled
                />
              </td>
              <td>
                <input
                  type="number"
                  className="form-control"
                  placeholder="0"
                  value={row.stock || ""}
                  min={0}
                  max={row.stock}
                  disabled
                  onChange={(e) => handleQty(i, e.target.value)}
                />
              </td>
              <td>
                {/* Return quantity — user editable, capped at purchase_quantity */}
                <input
                  type="number"
                  className="form-control"
                  placeholder="0"
                  value={row.return_quantity === 0 ? "" : row.return_quantity ?? ""}
                  min={0}
                  max={row.purchase_quantity}
                  onChange={(e) => handleQty(i, e.target.value)}
                />
              </td>

              <td>
                <input
                  className="form-control bg-light"
                  value={row.product_rate}
                  disabled
                />
              </td>

              <td>
                <input
                  type="number"
                  className="form-control"
                  placeholder="0.00"
                  value={row.discount || ""}
                  onChange={(e) => handleDisc(i, e.target.value)}
                />
              </td>

              <td>{Number(row.total).toFixed(2)}</td>
            </tr>
          ))}

          {/* FOOTER ROW: RETURN REASON + BUTTON */}
          <tr>
            <td colSpan="4">
              <textarea
                className="form-control"
                placeholder="Return Reason"
                value={returnReason}
                onChange={(e) => setReturnReason(e.target.value)}
              />
            </td>

            <td className="text-end fw-bold">Grand Total:</td>
            <td className="fw-bold">{grandTotal.toFixed(2)}</td>
          </tr>

          <tr>
            <td colSpan="6" className="text-end">
              <button
                className="btn btn-primary px-5"
                disabled={loading || !canSubmit}
                onClick={handleSubmit}
              >
                {loading ? "Submitting..." : "Submit Return Invoice"}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default PurchaseReturnItemsTable;
